export * from './blockIconsTextformattingDescriptionNew';
export * from './blockIconsTextformattingContentCopyNew';
export * from './blockIconsTextformattingDashboardNew';
export * from './blockIconsTextformattingEditNoteNew';
export * from './blockIconsTextformattingMenuBookNew';
export * from './blockIconsTextformattingGridViewNew';
export * from './blockIconsTextformattingListNew';
export * from './blockIconsTextformattingFolderNew';
export * from './blockIconsTextformattingListAltNew';
export * from './blockIconsTextformattingInventoryNew';
export * from './blockIconsTextformattingFolderOpenNew';
export * from './blockIconsTextformattingArticleNew';
export * from './blockIconsTextformattingFactCheckNew';
export * from './blockIconsTextformattingAttachFileNew';
export * from './blockIconsTextformattingFormatListBulletedNew';
export * from './blockIconsTextformattingAssignmentNew';
export * from './blockIconsTextformattingTaskNew';
export * from './blockIconsTextformattingChecklistNew';
export * from './blockIconsTextformattingCloudUploadNew';
export * from './blockIconsTextformattingDraftNew';
export * from './blockIconsTextformattingCloudNew';
export * from './blockIconsTextformattingSummarizeNew';
export * from './blockIconsTextformattingDrawNew';
export * from './blockIconsTextformattingFeedNew';
export * from './blockIconsTextformattingNewspaperNew';
export * from './blockIconsTextformattingViewListNew';
export * from './blockIconsTextformattingFileCopyNew';
export * from './blockIconsTextformattingNoteAddNew';
export * from './blockIconsTextformattingBorderColorNew';
export * from './blockIconsTextformattingBookNew';
export * from './blockIconsTextformattingDesignServicesNew';
export * from './blockIconsTextformattingHistoryEduNew';
export * from './blockIconsTextformattingPendingActionsNew';
export * from './blockIconsTextformattingFormatQuoteNew';
export * from './blockIconsTextformattingPostAddNew';
export * from './blockIconsTextformattingRequestQuoteNew';
export * from './blockIconsTextformattingCloudDownloadNew';
export * from './blockIconsTextformattingDragHandleNew';
export * from './blockIconsTextformattingTableNew';
export * from './blockIconsTextformattingContactPageNew';
export * from './blockIconsTextformattingArchiveNew';
export * from './blockIconsTextformattingSpaceDashboardNew';
